import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import { StyledTextField, StyledButton } from '../../../../Components/Generics.styled';

const ComfortableBudgetContainer = styled.div`
    /* border: 1px solid red; */
    display: flex;
    flex-direction: column;
`;

const NavButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Btn = styled(StyledButton)`
    width: 100%;
    max-width: 360px;
    border: 1px solid white;
`;

const ComfortableBudget = ({
    handleNavButtonBack,
    handleNavButtonNext,
    teachDavieData,
    setTeachDavieData,
}) => {
    const { budget } = { ...teachDavieData };
    const [value, setValue] = useState(100);

    useEffect(() => {
        if (budget !== '') {
            setValue(budget);
        }
    }, [budget]);

    const handleNext = () => {
        setTeachDavieData((prev) => ({ ...prev, budget: parseInt(value) }));
        handleNavButtonNext();
    };

    return (
        <ComfortableBudgetContainer>
            <StyledTextField
                label="What is a comfortable monthly advertising budget range for advertising your business?"
                value={value}
                onChange={(e) => {
                    setValue(e.target.value);
                }}
                placeholder="Enter your estimated budget"
            />
            <br />
            <NavButtonContainer>
                <Btn onClick={() => handleNavButtonBack()}>Previous</Btn>
                <Btn onClick={() => handleNext()}>Send</Btn>
            </NavButtonContainer>
        </ComfortableBudgetContainer>
    );
};

ComfortableBudget.propTypes = {
    handleNavButtonBack: propTypes.func,
    handleNavButtonNext: propTypes.func,
    teachDavieData: propTypes.shape({}),
    setTeachDavieData: propTypes.func,
};

ComfortableBudget.defaultProps = {
    handleNavButtonBack: () => {},
    handleNavButtonNext: () => {},
    teachDavieData: {},
    setTeachDavieData: () => {},
};

export default ComfortableBudget;
